import { Skeleton } from 'antd';
import { styled } from 'styled-components';
export const Contaienr = styled.div.withConfig({
  displayName: "GroupTrendstyle__Contaienr",
  componentId: "sc-1sa82zs-0"
})(["", " @media (max-width:", "){", "}"], {
  "paddingBottom": "120px",
  "paddingTop": "5rem",
  "textAlign": "center"
}, ({
  theme
}) => theme.breakpoint.md, {
  "paddingBottom": "2rem",
  "paddingTop": "2.5rem",
  "textAlign": "center"
});
export const TitleSkeleton = styled(Skeleton.Button).withConfig({
  displayName: "GroupTrendstyle__TitleSkeleton",
  componentId: "sc-1sa82zs-1"
})(["", " @media (max-width:", "){", "}"], {
  "marginBottom": "1rem",
  "height": "4rem !important",
  "width": "360px !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "0.75rem",
  "height": "2.75rem !important",
  "width": "250px !important"
});
export const Wrapper = styled.div.withConfig({
  displayName: "GroupTrendstyle__Wrapper",
  componentId: "sc-1sa82zs-2"
})(["", " @media (max-width:", "){", "}"], {
  "marginTop": "2.5rem",
  "marginBottom": "2.5rem",
  "display": "flex",
  "justifyContent": "center",
  "gap": "2.5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "0.5rem",
  "marginBottom": "0.5rem",
  "gap": "2rem"
});
export const GroupButtonSkeleton = styled(Skeleton.Button).withConfig({
  displayName: "GroupTrendstyle__GroupButtonSkeleton",
  componentId: "sc-1sa82zs-3"
})(["", " @media (max-width:", "){", "}"], {
  "height": "5rem !important",
  "width": "18rem !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "height": "3rem !important",
  "width": "10rem !important"
});